(function () {
  function scopeOf(el) {
    return el.closest('fieldset, .select__fieldset, .radio__fieldset') || document;
  }
  function setLegendFrom(el) {
    const scope = scopeOf(el);
    const target = scope && scope.querySelector('[data-legend-target]');
    if (!target) return;

    // Prefer our custom legend text
    let txt = el.dataset && el.dataset.legend;
    // Fallback to raw value if metafield is empty
    if (!txt) {
      if (el.tagName === 'INPUT') txt = el.value || '';
      if (el.tagName === 'A') txt = el.getAttribute('data-value') || el.textContent.trim();
    }
    if (txt) target.textContent = txt;
  }

  // Radios
  document.addEventListener('change', function (e) {
    if (e.target.matches('input[type="radio"][data-legend]')) {
      setLegendFrom(e.target);
    }
  });

  // Popout select options
  document.addEventListener('click', function (e) {
    const a = e.target.closest('a.select-popout__option[data-legend]');
    if (a) setLegendFrom(a);
  });

  // Initialize on load
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('input[type="radio"][data-legend]:checked').forEach(setLegendFrom);
    // Also initialize selects using currently active option
    document.querySelectorAll('.select-popout__item.is-active a.select-popout__option[data-legend]').forEach(setLegendFrom);
  });
})();
